import gql from 'graphql-tag';

export const GET_IMPACT_POSTS = gql`
  query GetImpactPosts(
    $start: PositiveInt!
    $end: PositiveInt!
    $search: String
  ) {
    getImpactPosts(input: { start: $start, end: $end, search: $search }) {
      totalCount
      posts {
        id
        content {
          visible
          language
          title
          description
          image
          imageFullPath
          socialMediaCardImage
          socialMediaCardImageFullPath
          clickUrl
          clickUrlLabel
          postDate
          likeEnabled
          shareEnabled
        }
      }
    }
  }
`;

export const CREATE_IMPACT_POST = gql`
  mutation CreateImpactPost($content: [CreateImpactPostContainerInput]) {
    createImpactPost(input: { content: $content }) {
      done
      id
      impactPost {
        content {
          visible
          language
          title
          description
          image
          imageFullPath
          socialMediaCardImage
          socialMediaCardImageFullPath
          clickUrl
          clickUrlLabel
          postDate
          likeEnabled
          shareEnabled
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const UPDATE_IMPACT_POST = gql`
  mutation UpdateImpactPost(
    $id: ID!
    $content: [UpdateImpactPostContainerInput]
  ) {
    updateImpactPost(input: { id: $id, content: $content }) {
      done
      id
      impactPost {
        content {
          visible
          language
          title
          description
          image
          imageFullPath
          socialMediaCardImage
          socialMediaCardImageFullPath
          clickUrl
          clickUrlLabel
          postDate
          likeEnabled
          shareEnabled
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const REMOVE_IMPACT_POST = gql`
  mutation RemoveImpactPost($id: ID!) {
    removeImpactPost(input: { id: $id }) {
      done
      errors {
        field
        message
      }
    }
  }
`;
